import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealerBuyComponent } from './dealer-buy.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { DealerAccountComponent } from '../dealer/dealer-account/dealer-account.component';
import { DealerPublicComponent } from '../dealer/dealer-public/dealer-public.component';
import { CustomerBuyComponent } from '../customer/customer-buy/customer-buy.component';
import { DealerAlertsComponent } from '../dealer/dealer-alerts/dealer-alerts.component';
import { NotFoundComponent } from 'src/app/auth/not-found/not-found.component';
import { MenuNode } from '../common/dealer-menu/dealer-menu.component';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { TransactionStage } from 'src/app/public/common/constants/common-basic-data';
import { SessionBasicData, MenuCode } from 'src/app/public/common/constants/session-basic-data';


const menuItems: MenuNode[] = SessionBasicData.getChildren(MenuCode.BUY)

const menuNode: MenuNode = SessionBasicData.getNode(MenuCode.BUY)


const routes: Routes = [
  { path: '', component: DealerBuyComponent,
    children: [
      { path: 'favorites', canActivate: [AuthGuard], component: CustomerBuyComponent, data: menuNode.children!.find((item) => item.code === MenuCode.BUY_FAVORITE) },
      
      { path: 'drafts', canActivate: [AuthGuard], component: CustomerBuyComponent, data: menuNode.children!.find((item) => item.code === MenuCode.BUY_DRAFT) },
      { path: 'sent', canActivate: [AuthGuard], component: CustomerBuyComponent, data: menuNode.children!.find((item) => item.code === MenuCode.BUY_PENDING) },
      { path: 'ongoing', canActivate: [AuthGuard], component: CustomerBuyComponent, data: menuNode.children!.find((item) => item.code === MenuCode.BUY_ONGOING) },
      { path: 'completed', canActivate: [AuthGuard], component: CustomerBuyComponent, data: menuNode.children!.find((item) => item.code === MenuCode.BUY_COMPLETED) },
      
      { path: 'alerts', canActivate: [AuthGuard], component: DealerAlertsComponent, data: { businessLine: CarBusinessLine.BUY }  },
      
      { path: '**', component: NotFoundComponent },
    ]
  },
];

const routesOld: Routes = [
  { path: '', component: DealerBuyComponent,
    children: [
      { path: 'favorites', canActivate: [AuthGuard], component: CustomerBuyComponent, data: { transactionStages: [TransactionStage.FAVORITE] }},
      
      { path: 'drafts', canActivate: [AuthGuard], component: CustomerBuyComponent, data: { transactionStages: [TransactionStage.DRAFT] }},
      { path: 'ongoing', canActivate: [AuthGuard], component: CustomerBuyComponent, data: { transactionStages: [TransactionStage.PENDING, TransactionStage.MODIF, TransactionStage.CONFIRMED, TransactionStage.ONGOING ] }},
      { path: 'completed', canActivate: [AuthGuard], component: CustomerBuyComponent, data: { transactionStages: [TransactionStage.COMPLETED] }},
      
      { path: 'alerts', canActivate: [AuthGuard], component: DealerAlertsComponent, data: { businessLine: CarBusinessLine.BUY }  },
      
      { path: '**', component: NotFoundComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealerBuyRoutingModule { }
